module.exports = __webpack_public_path__ + "static/img/RE@3x.8f658e2a.jpg";